
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CompanyList } from '@/components/admin/CompanyList';
import { CompanyDetail } from '@/components/admin/CompanyDetail';
import { CompanyDomains } from '@/components/admin/CompanyDomains';
import NotFound from '@/components/NotFound';
import AdminLayout from '@/layouts/AdminLayout';
import { useAuth } from '@/hooks/use-auth';
import { Navigate } from 'react-router-dom';
import { AccessRequests } from '@/routes/lazy-routes';

export default function AdminRoutes() {
  const { currentUser, isLoading } = useAuth();
  
  // Verificar si el usuario es administrador
  const isAdmin = currentUser?.role === 'admin' || currentUser?.role === 'superadmin';
  
  if (isLoading) return <div>Cargando...</div>;
  
  // Si no es admin, redirigir al dashboard
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="companies" element={<CompanyList />} />
        <Route path="companies/:companyId" element={<CompanyDetail />} />
        <Route path="companies/:companyId/domains" element={<CompanyDomains />} />
        <Route path="access-requests" element={<AccessRequests />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
